import React from 'react'
import {isEmpty} from 'lodash'
import {Redirect} from 'react-router-dom'
import Snackbar from 'material-ui-legacy/Snackbar'
import ActionCompareArrows from 'material-ui-legacy/svg-icons/action/compare-arrows'
import ActionCheckCircle from 'material-ui-legacy/svg-icons/action/check-circle'
import {deepOrange500, lightGreenA700} from 'material-ui-legacy/styles/colors'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import AgencyForm from './AgencyForm'

import Resource from '../../stores/resource'
const AgencyStore = Resource('agencies')

class EditAgency extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      agency: (this.props.agency || {}),
      changed: false,
      saved: false,
      error: '',
      snackbarMessage: ''
    }
  }

  _save = (attributes) => {
    AgencyStore.update(this.state.agency.id, attributes)
    .then((result) => {
      this.setState({
        saved: true,
        changed: false,
        error: '',
        savedAgency: result.data.data,
        snackbarMessage: `Agency "${attributes.name}" saved!`
      },
      () => {
        if (this.props.savedCallback) {
          this.props.savedCallback(this.state.savedAgency)
        }
      })
    })
    .catch((error) => {
      this.setState({
        saved: false,
        error: errors.unpack(error)
      })
    })
  }

  _changed = (didChange) => this.setState({changed: didChange, saved: false})

  _closeErrorDialog = () => this.setState({error: ''})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect}/>

    const agency = (isEmpty(this.state.agency)) ? null : this.state.agency

    const changed = this.state.changed
    const saved = this.state.saved

    return (
      <section>
        <AgencyForm
          formTitle={
            <span>
              {agency.attributes.name}&nbsp;
              {changed && <ActionCompareArrows color={deepOrange500}/>}
              {saved && <ActionCheckCircle color={lightGreenA700}/>}
            </span>
          }
          agency={agency}
          changedCallback={this._changed}
          submitCallback={this._save}
          cancelCallback={() => this._redirectTo("/agencies")}
        />

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't save your changes">
          <p>
            The agency <strong>{agency.name}</strong> remains unchanged.
          </p>
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default EditAgency



// WEBPACK FOOTER //
// ./src/components/Agencies/EditAgency.jsx